import { A11y, Navigation } from 'swiper/modules';

class StoreFinderLogos {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-storefinderlogos'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$storeFinderLogos = $element;
        this.$slider = this.$storeFinderLogos.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$$slides = this.$storeFinderLogos.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.slider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;
        this.orderList = [];

        if (this.$$slides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        for (let index = 0; index < this.$$slides.length; index++) {
            this.defineOrder(this.$$slides[index]);
        }

        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    setOrder () {
        if (this.$$slides.length > 0) {
            for (let index = 0; index < this.$$slides.length; index++) {
                const order = this.$$slides[index].getAttribute('data-storefinderlogos-index');
                this.$$slides[index].style.setProperty('--order', `${order}`);
            }
        }
    }

    defineOrder (logo) {
        const order = Math.floor(Math.random() * (this.$$slides.length) + 1);

        if (this.orderList.indexOf(order) === -1) {
            this.orderList.push(order);
            logo.setAttribute('data-storefinderlogos-index', order);
        } else {
            this.defineOrder(logo);
        }
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$$slides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1024 && this.$$slides.length > 2) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }

        this.setOrder();
    }

    initSlider () {
        this.slider = new this.Slider(this.$slider, {
            modules: [A11y, Navigation],
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            initAttr: this.settings.initAttr,
            breakpoints: {
                768: {
                    slidesPerGroup: 3
                }
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.slider !== 'undefined' && this.slider !== null) {
            this.slider.destroy();
        }
    }
}

export { StoreFinderLogos };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$storeFinderLogos = $context.querySelectorAll('[data-storefinderlogos="root"]');
        for (let i = 0; i < $$storeFinderLogos.length; i++) {
            const $storeFinderLogos = $$storeFinderLogos[i];

            const StoreFinderLogosAPI = new StoreFinderLogos($storeFinderLogos);
            $storeFinderLogos.API = StoreFinderLogosAPI;
        }
    }
});
